import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'libPhoneFormat',
  pure: true,
  standalone: true,
})
export class PhoneFormatPipe implements PipeTransform {
  private readonly PHONE_NUMBER_LENGTH = 10;
  private readonly PREFIX_LENGTH = 3;

  public transform(value: string | undefined): string {
    if (!value) return '';

    const digits = value.toString().replaceAll(/\D/g, '');
    if (digits.length !== this.PHONE_NUMBER_LENGTH) return value;

    return `(${digits.slice(0, this.PREFIX_LENGTH)}) ${digits.slice(
      this.PREFIX_LENGTH,
      this.PREFIX_LENGTH + this.PREFIX_LENGTH,
    )}-${digits.slice(this.PREFIX_LENGTH + this.PREFIX_LENGTH)}`;
  }
}
